import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { Product } from '../../../../_models/product';
import { CardService } from '../../card.service';

@Component({
  moduleId: module.id,
  selector: 'copy-to-product-component',
  templateUrl: 'copy-to-product.component.html',
  // styleUrls: ['./upload-photo.component.css']
  styleUrls: ['./copy-to-product.component.css']
})
export class CopyToProductComponent implements OnInit {
  @Input() product: Product;
  @Output() copyToProducts = new EventEmitter<number[]>();
  public copyToProductsForm: FormGroup;

  constructor(private formBuilder: FormBuilder, public cardService: CardService) {}

  ngOnInit() {
    this.copyToProductsForm = this.formBuilder.group({
      'products': [''],
    });
    this.copyToProductsForm.valueChanges.subscribe(data => {
      this.copyToProducts.emit(data);
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/hq/cards/copy-configuration/copy-to-product/copy-to-product.component.ts